var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-links"},[_c('router-link',{attrs:{"to":"/reclamacoes"}},[_c('img',{attrs:{"src":require("@/assets/img/icons/award.svg")}}),_vm._v(" Reclamações ")]),_c('Logout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }